// Force-Build: 2
import appEnv from 'bundles/browse/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
